import { render, staticRenderFns } from "./GridHotels.vue?vue&type=template&id=396b8662&"
import script from "./GridHotels.vue?vue&type=script&lang=js&"
export * from "./GridHotels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('396b8662')) {
      api.createRecord('396b8662', component.options)
    } else {
      api.reload('396b8662', component.options)
    }
    module.hot.accept("./GridHotels.vue?vue&type=template&id=396b8662&", function () {
      api.rerender('396b8662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hotels/grid/GridHotels.vue"
export default component.exports